(function() {
  function ls() {
    var e = document.createElement('script');
    e.src = 'https://cdn.siftscience.com/s.js';
    document.body.appendChild(e);
  }
  if (window.attachEvent) {
    window.attachEvent('onload', ls);
  } else {
    window.addEventListener('load', ls, false);
  }
})();
